import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';
import { createAppConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { loadStorefrontRuntimeConfig } from './environments/runtime-config';

if (environment.production) {
  enableProdMode();
}

async function start(): Promise<void> {
  await loadStorefrontRuntimeConfig();
  await bootstrapApplication(AppComponent, createAppConfig());

  // Error reporting is initialized after the application becomes interactive.
  // Replay is intentionally disabled; traces stay sampled.
  if (environment.sentryEnabled) {
    window.setTimeout(() => {
      import('@sentry/angular').then((Sentry) => {
        Sentry.init({
          dsn: environment.sentry,
          release: environment.release,
          environment: environment.runtimeEnvironment,
          integrations: [Sentry.browserTracingIntegration()],
          tracesSampleRate: 0.1,
        });
        Sentry.setContext('app', { name: 'LK_Market', version: environment.version });
      });
    }, 3000);
  }
}

start().catch((error: unknown) => {
  document.body.textContent = 'Конфигурация приложения недоступна. Обратись в поддержку.';
  console.error(error);
});
